import React from 'react';
import { ReactComponent as VolumeUnMutedIcon } from '../volume.svg';
import { ReactComponent as VolumeMutedIcon } from '../volume-muted.svg';

interface IProps extends React.SVGProps<SVGSVGElement> {
    muted: boolean;
}

export const VolumeIcon: React.FC<IProps> = (props) =>
    // eslint-disable-next-line react/jsx-props-no-spreading
    props.muted ? <VolumeMutedIcon {...props} /> : <VolumeUnMutedIcon {...props} />;
